import type { UseFormSetValue } from 'react-hook-form'

import type { SearchFilters } from '../../../schemas/marketplace/filters'
import { formatCity, formatState } from '../../../utils/format-location'

type HandlePlaceDetailsProps = {
  placesService: google.maps.places.PlacesService | null
  inputRef: React.RefObject<HTMLInputElement | null>
  setSearchInput: (value: string) => void
  setValue: UseFormSetValue<SearchFilters>
  setSelectedLocation: (location: string) => void
}

export const handlePlaceDetails = ({
  placesService,
  inputRef,
  setSearchInput,
  setValue,
  setSelectedLocation,
}: HandlePlaceDetailsProps) => {
  return (placeId: string) => {
    if (!placesService) return

    placesService.getDetails(
      {
        placeId: placeId,
      },
      (placeDetails: google.maps.places.PlaceResult | null) => {
        if (!placeDetails) return

        const addressComponents = placeDetails.address_components || []
        const geometry = placeDetails.geometry || {}

        const getComponent = (types: string[]) => {
          for (const type of types) {
            const component = addressComponents.find((component) => component.types.includes(type))
            if (component) {
              if (type === 'administrative_area_level_1' || type === 'administrative_area_level_2') {
                return component.short_name
              }
              return component.long_name
            }
          }
          return ''
        }

        const city = getComponent([
          'locality',
          'postal_town',
          'sublocality',
          'neighborhood',
          'administrative_area_level_2',
        ])
        const state = getComponent(['administrative_area_level_1', 'administrative_area_level_2'])

        if (inputRef.current) {
          // Use the common formatCity and formatState functions
          const formattedCity = formatCity(city)
          const formattedState = formatState(state)

          const displayValue = [formattedCity, formattedState].filter(Boolean).join(', ')

          inputRef.current.value = displayValue
          setSearchInput(displayValue)
          setValue('location', displayValue)
          setValue('city', formattedCity)
          setValue('state', formattedState)
          setValue('latitude', geometry.location?.lat() || 0)
          setValue('longitude', geometry.location?.lng() || 0)
          setSelectedLocation(displayValue)
        }
      },
    )
  }
}
